import React, { useEffect, useState } from "react";
import "./revenueLineChart.scss";
import orderStore from "../../../stores/orderStore";
import { ResponsiveLine } from "@nivo/line";
import { Skeleton } from "@mui/material";

const RevenueLineChart = () => {
  const OrderStore = orderStore();

  const [totalEarningData, setTotalEarningData] = useState([
    {
      id: "Total Profit",
      color: "#171717",
      data: [],
    },
  ]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!OrderStore.isLoading) {
      const today = new Date();
      const thisYear = today.getFullYear();
      let jan = 0;
      let feb = 0;
      let mar = 0;
      let arp = 0;
      let may = 0;
      let jun = 0;
      let jul = 0;
      let aug = 0;
      let sep = 0;
      let oct = 0;
      let nov = 0;
      let dec = 0;

      if (OrderStore.orderDetail) {
        OrderStore.orderDetail.map((item) => {
          if (item.order_delivery_status === "Delivered") {
            const itemDate = new Date(item.order_at);
            if (itemDate.getFullYear() === thisYear) {
              const ch = itemDate.getMonth() + 1;
              switch (ch) {
                case 1:
                  jan = jan + item.purchasePrice;
                  break;
                case 2:
                  feb = feb + item.purchasePrice;
                  break;
                case 3:
                  mar = mar + item.purchasePrice;
                  break;
                case 4:
                  arp = arp + item.purchasePrice;
                  break;
                case 5:
                  may = may + item.purchasePrice;
                  break;
                case 6:
                  jun = jun + item.purchasePrice;
                  break;
                case 7:
                  jul = jul + item.purchasePrice;
                  break;
                case 8:
                  aug = aug + item.purchasePrice;
                  break;
                case 9:
                  sep = sep + item.purchasePrice;
                  break;
                case 10:
                  oct = oct + item.purchasePrice;
                  break;
                case 11:
                  nov = nov + item.purchasePrice;
                  break;
                case 12:
                  dec = dec + item.purchasePrice;
                  break;
                default:
                  break;
              }
            }
          }
        });
      }

      const totalEarningLine = {
        id: "Total Profit",
        color: "#171717",
        data: [
          { x: "Jan", y: jan },
          { x: "Feb", y: feb },
          { x: "Mar", y: mar },
          { x: "Arp", y: arp },
          { x: "May", y: may },
          { x: "Jun", y: jun },
          { x: "Jul", y: jul },
          { x: "Aug", y: aug },
          { x: "Sep", y: sep },
          { x: "Oct", y: oct },
          { x: "Nov", y: nov },
          { x: "Dec", y: dec },
        ],
      };

      setTotalEarningData([totalEarningLine]);
      setIsLoading(false);
    }
  }, [OrderStore.isLoading]);

  // const [totalSalesLine, totalUnitsLine] = useMemo(() => {});

  return (
    <div className="revenue-line-chart">
      {isLoading ? (
        <Skeleton variant="rounded" width="100%" height="100%" />
      ) : (
        <ResponsiveLine
          data={totalEarningData}
          theme={{
            axis: {
              domain: {
                line: {
                  stroke: "#171717",
                  strokeWidth: 1,
                },
              },
              legend: {
                text: {
                  fill: "#171717",
                },
              },
              ticks: {
                line: {
                  stroke: "#171717",
                  strokeWidth: 1,
                },
                text: {
                  fill: "#171717",
                },
              },
            },
            legends: {
              text: {
                fill: "#171717",
              },
            },
            tooltip: {
              container: {
                color: "#171717",
              },
            },
          }}
          margin={{ top: 10, right: 30, bottom: 50, left: 50 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: false,
            reverse: false,
          }}
          yFormat=" >-.2f"
          curve="catmullRom"
          // enableArea={isDashboard}
          enableArea={true}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            // format: (v) => {
            //   if (isDashboard) return v.slice(0, 3);
            // },
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            // legend: isDashboard ? "" : "Month",
            legend: "Month",
            legendOffset: 36,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickValues: 5,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "",
            // legend: isDashboard
            //   ? ""
            //   : `Total ${view === "sales" ? "Revenue" : "Units"} for Year`,
            legendOffset: -60,
            legendPosition: "middle",
          }}
          enableGridX={false}
          enableGridY={false}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          // pointBorderColor={{ from: "serieColor" }}
          pointLabelYOffset={-12}
          useMesh={true}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 30,
              translateY: -40,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "rgba(0, 0, 0, .03)",
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
        />
      )}
    </div>
  );
};

export default RevenueLineChart;
